module.exports = __webpack_public_path__ + "img/1557614076649086978.8d4d9f10.png";